<template>
  <!-- Главная ЛК по ТЗ «Описание функциональных элементов на главной странице»
       в стиле дизайн-системы СТОУН-XXI: лимит → онлайн-лизинг и быстрый расчёт →
       договоры и фотоштрафы → спецпредложения → с пробегом → новая техника → КП.
       Вместо спиннера на время загрузки блоки целиком переливаются (st-skel-block):
       разметка внутри та же и только скрыта, поэтому размеры совпадают -->
  <div class="st st-home">
    <div class="st-home__inner">
      <!-- приветствие отключено (кнопка «Избранное» — в шапке ЛК).
           Вернуть: раскомментировать (greeting и company — в computed)
      <div class="st-greet">
        <div>
          <h1>{{ greeting }}</h1>
          <p v-if="company" class="st-eyebrow">{{ company }}</p>
        </div>
      </div>
      -->

      <div class="st-stack">
        <!-- «Важная информация!» из lkAdv.php — отключено: там устаревшие данные.
             Вернуть: раскомментировать блок и загрузку news в start()
        <div v-if="news.NAME && news.LINK" class="st-panel st-notice">
          <span class="st-notice__label">Важная информация!</span>
          <span v-if="news.DATE" class="st-note">{{ news.DATE }}</span>
          <a :href="news.LINK" target="_blank" rel="noopener">{{ news.NAME }}</a>
        </div>
        -->

        <LimitBlock
          v-if="!indexLoading && limit > 0"
          :amount="limit"
        />

        <!-- «Онлайн-лизинг» и «Быстрый расчёт» — одна строка из двух карточек
             (прототип V3). Ссылки — якоря к разделам витрины ниже и заявка на
             недвижимость; пока каталог грузится, вместо них переливаются
             заготовки той же высоты -->
        <section class="st-hero" aria-labelledby="online-h">
          <div class="st-hero__main">
            <img class="st-hero__photo" :src="heroPhoto" alt="" />
            <div>
              <h2 id="online-h" class="st-display">Онлайн-лизинг</h2>
              <p class="st-hero__lead">
                Подберите технику или недвижимость и оформите заявку, не выходя
                из кабинета.
              </p>
            </div>
            <div class="st-hero__stats">
              <div class="st-stat"><b>от 5%</b><span>аванс</span></div>
              <div class="st-stat"><b>до 60 мес.</b><span>срок</span></div>
              <div class="st-stat"><b>ЭДО</b><span>без визита в офис</span></div>
            </div>

            <div v-if="catalogLoading" class="st-hero__links" aria-hidden="true">
              <div v-for="n in 4" :key="n" class="st-hero-link st-skel-block">
                <span class="st-hero-link__icon"></span>
                <span class="st-hero-link__text">
                  <b>Раздел</b><small>0 предложений</small>
                </span>
              </div>
            </div>
            <nav v-else class="st-hero__links" aria-label="Разделы витрины">
              <button
                v-for="tile in tiles"
                :key="tile.id"
                class="st-hero-link"
                :class="tile.request && 'is-request'"
                type="button"
                @click="openTile(tile)"
              >
                <span
                  class="st-hero-link__icon"
                  :class="tile.hot && 'is-hot'"
                  v-html="tile.icon"
                ></span>
                <span class="st-hero-link__text">
                  <b>{{ tile.title }}</b>
                  <small>{{
                    tile.note || tile.total + " " + pluralOffers(tile.total)
                  }}</small>
                </span>
                <svg
                  class="st-hero-link__arrow"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <!-- раздел ниже — шеврон вниз, заявка (недвижимость) — вправо -->
                  <path :d="tile.request ? 'M9 6l6 6-6 6' : 'M6 9l6 6 6-6'" />
                </svg>
              </button>
            </nav>
          </div>

          <QuickCalc />
        </section>

        <div class="st-services">
          <RouterLink
            class="st-panel st-service"
            :class="indexLoading && 'st-skel-block'"
            :aria-busy="indexLoading"
            to="/contracts"
          >
            <div class="st-service__top">
              <b>Договоры</b><RightIcon />
            </div>
            <span class="st-eyebrow"
              >Действующих договоров: {{ Number(contracts.count) || 0 }}</span
            >
            <span class="st-service__value">{{ money(contracts.sum) }}</span>
            <div
              class="st-progress"
              role="img"
              :aria-label="'Выплачено ' + paidPercent + '%'"
            >
              <span :style="{ width: paidPercent + '%' }"></span>
            </div>
            <div class="st-service__row">
              <span>Выплачено</span><b>{{ money(contracts.paid) }}</b>
            </div>
            <!-- строка долга есть всегда — высота карточки не меняется -->
            <div v-if="debt < 0" class="st-service__row">
              <span>Переплата</span
              ><b class="st-text-success">{{ money(-debt) }}</b>
            </div>
            <div v-else-if="debt > 0" class="st-service__row">
              <span>Задолженность</span
              ><b class="st-text-danger">{{ money(debt) }}</b>
            </div>
            <div v-else class="st-service__row">
              <span>Задолженность</span><b>нет</b>
            </div>
          </RouterLink>

          <RouterLink
            class="st-panel st-service"
            :class="indexLoading && 'st-skel-block'"
            :aria-busy="indexLoading"
            to="/accounting/photofine"
          >
            <div class="st-service__top">
              <b>Фотоштрафы</b><RightIcon />
            </div>
            <!-- тот же каркас, что у «Договоров»: подпись, сумма, пустая полоса
                 и две строки — карточки всегда одной высоты -->
            <span class="st-eyebrow">К оплате</span>
            <span class="st-service__value">{{ money(photofine.sum) }}</span>
            <div class="st-progress" aria-hidden="true"></div>
            <div class="st-service__row">
              <span>Не оплачено штрафов</span>
              <b v-if="Number(photofine.count)">{{ Number(photofine.count) }}</b>
              <b v-else>нет</b>
            </div>
            <div class="st-service__row">
              <span>Новых за 14 дней: {{ Number(photofine.countNew) || 0 }}</span
              ><b>{{ money(photofine.sumNew) }}</b>
            </div>
          </RouterLink>
        </div>
      </div>

      <CatalogSkeleton v-if="catalogLoading" />

      <template v-else-if="catalogLoaded">
        <CatalogSection
          v-if="sections.special.total"
          id="special"
          title="Спецпредложения"
          sub="Особые условия от партнёров"
          :all-to="{ path: '/catalog', query: { type: 'special' } }"
          :query="{ special: true }"
          :initial="sections.special"
          :applying-id="applyingId"
          @apply="apply"
          @error="showError"
        />

        <CatalogSection
          v-if="sections.used.total"
          id="used"
          title="Техника с пробегом"
          sub="Проверена и готова к передаче"
          :all-to="{ path: '/catalog', query: { type: 'used' } }"
          :query="{ type: 'used' }"
          :initial="sections.used"
          :combos="usedCombos"
          :applying-id="applyingId"
          @apply="apply"
          @error="showError"
        />

        <CatalogSection
          v-if="sections.new.total"
          id="new"
          title="Новая техника"
          sub="Автомобили и спецтехника от партнёров"
          :all-to="{ path: '/catalog', query: { type: 'new' } }"
          :query="{ type: 'new' }"
          :initial="sections.new"
          :combos="newCombos"
          :applying-id="applyingId"
          @apply="apply"
          @error="showError"
        />
      </template>

      <section class="st-section st-kp" aria-labelledby="kp-h">
        <div>
          <h2 id="kp-h" class="st-heading">
            Уже есть счёт или КП от поставщика?
          </h2>
          <p class="mt-1">
            Приложите документ — персональный менеджер подготовит расчёт на
            Вашу технику.
          </p>
        </div>
        <button
          class="st-btn st-btn--primary st-btn--lg"
          type="button"
          style="padding: 0 28px"
          @click="kpOpen = true"
        >
          Получить расчёт по КП
        </button>
      </section>
    </div>

    <!-- позиция без типа предмета лизинга или плитка «Недвижимость»:
         заявка менеджеру с предзаполненными полями -->
    <ApplicationModal
      v-if="itemRequest"
      kind="own"
      :limit="limit"
      :initial="itemRequest"
      @close="itemRequest = null"
    />

    <!-- расчёт по КП поставщика: общая форма заявки с файлом -->
    <ApplicationModal
      v-if="kpOpen"
      kind="kp"
      :limit="limit"
      @close="kpOpen = false"
    />

    <ui-modal v-if="modal.msg" :close="modalClose">
      <div class="modal-header">
        <h5 class="modal-title">{{ modal.title }}</h5>
        <button class="btn-close" type="button" @click="modalClose"></button>
      </div>
      <div class="modal-body">{{ modal.msg }}</div>
      <div class="modal-footer"></div>
    </ui-modal>
  </div>
</template>

<script>
// import axios from "axios"; — нужен для «Важной информации!» (отключена)
import { mapGetters } from "vuex";
import { getApi } from "@/run";
import { getCatalogHome } from "@/views/catalog/api";
import RightIcon from "@/assets/svg/Right.vue";
import LimitBlock from "./components/LimitBlock.vue";
import QuickCalc from "./components/QuickCalc.vue";
import CatalogSection from "./components/CatalogSection.vue";
import CatalogSkeleton from "./components/CatalogSkeleton.vue";
import ApplicationModal from "@/component/application/ApplicationModal.vue";
import { fromCatalogItem } from "@/component/application/fromCatalogItem";
import { applyCatalogItem, money } from "./helpers";
import heroPhoto from "@/assets/img/hero-truck-2.webp";
import "./home.css";

// размер первой страницы подборок (как «Загрузить ещё» в каталоге)
const PAGE_SIZE = 6;

const TYPE_NEW = "Новая техника";

// иконки ссылок «Онлайн-лизинга» — SVG Font Awesome Free 6.4.0 (solid: tags,
// truck, car, building), вставлены как разметка, без подключения библиотеки.
// Font Awesome Free by @fontawesome - https://fontawesome.com
// License - https://fontawesome.com/license/free (Icons: CC BY 4.0) Copyright 2023 Fonticons, Inc.
const ICONS = {
  special:
    '<svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"><path d="M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>',
  used:
    '<svg width="24" height="24" viewBox="0 0 640 512" fill="currentColor" aria-hidden="true"><path d="M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/></svg>',
  new:
    '<svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"><path d="M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>',
  estate:
    '<svg width="24" height="24" viewBox="0 0 384 512" fill="currentColor" aria-hidden="true"><path d="M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"/></svg>',
};

const emptySection = () => ({ total: 0, data: [] });

export default {
  name: "Main",
  components: {
    RightIcon,
    LimitBlock,
    QuickCalc,
    CatalogSection,
    CatalogSkeleton,
    ApplicationModal,
  },
  data() {
    return {
      // идёт загрузка сводки ЛК (/index) и каталога — показываются скелеты
      indexLoading: true,
      catalogLoading: true,
      contracts: {},
      photofine: {},
      // одобренный лимит, ₽ (false — лимита нет)
      dicAppliedLimits: false,
      // «Важная информация!» с сайта (lkAdv.php)
      news: {},
      catalogLoaded: false,
      // сочетания тип / марка / модель / модификация для фильтров разделов
      combos: [],
      sections: {
        special: emptySection(),
        used: emptySection(),
        new: emptySection(),
      },
      // позиция, по которой сейчас оформляется заявка
      applyingId: null,
      // окно «Расчёт по вашему КП»
      kpOpen: false,
      // окно заявки: позиция без типа ПЛ или недвижимость (предзаполненные поля)
      itemRequest: null,
      modal: {},
      // фото техники в синей карточке «Онлайн-лизинга»
      heroPhoto,
    };
  },
  computed: {
    ...mapGetters({
      getCompany: "main/getCompany",
    }),
    company() {
      return this.getCompany?.company;
    },
    greeting() {
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 12) return "Доброе утро!";
      if (hour >= 12 && hour < 18) return "Добрый день!";
      if (hour >= 18 && hour < 23) return "Добрый вечер!";
      return "Доброй ночи!";
    },
    limit() {
      return Number(this.dicAppliedLimits) || 0;
    },
    debt() {
      return Number(this.contracts.debt) || 0;
    },
    paidPercent() {
      const sum = Number(this.contracts.sum) || 0;
      const paid = Number(this.contracts.paid) || 0;
      if (sum <= 0) return 0;
      return Math.min(100, Math.max(0, Math.round((paid / sum) * 100)));
    },
    usedCombos() {
      return this.combos.filter((combo) => combo.type !== TYPE_NEW);
    },
    newCombos() {
      return this.combos.filter((combo) => combo.type === TYPE_NEW);
    },
    // плитки «Онлайн-лизинга»: разделы каталога (только непустые) и недвижимость —
    // её в каталоге нет, плитка открывает заявку менеджеру с типом «Недвижимость»
    tiles() {
      const sections = [
        { id: "special", title: "Спецпредложения", hot: true },
        { id: "used", title: "С пробегом" },
        { id: "new", title: "Новая техника" },
      ]
        .map((tile) => ({
          ...tile,
          icon: ICONS[tile.id],
          total: this.sections[tile.id].total,
        }))
        .filter((tile) => tile.total > 0);
      return [
        ...sections,
        {
          id: "estate",
          title: "Недвижимость",
          note: "Офисы и склады",
          icon: ICONS.estate,
          request: true,
        },
      ];
    },
  },
  created() {
    document.title = "Главная - STONE-XXI";
    // белая шапка на сером фоне главной (стили — home.css)
    document.body.classList.add("page-home");
    this.start();
  },
  beforeUnmount() {
    document.body.classList.remove("page-home");
  },
  methods: {
    money,
    // страница видна сразу; сводка ЛК и каталог грузятся параллельно и
    // независимо (избранное грузит шапка) — каждый блок заменяет свой скелет,
    // сбой одного не мешает остальным
    start() {
      this.indexLoading = true;
      this.catalogLoading = true;

      // «Важная информация!» отключена (см. шаблон)
      // axios
      //   .get("https://www.stone-xxi.ru/sale/lkAdv.php")
      //   .then((response) => {
      //     if (response.data?.NEWS) this.news = response.data.NEWS;
      //   })
      //   .catch(() => {});

      getApi("/index", {})
        .then((response) => {
          if (response?.status) {
            this.contracts = response.contracts;
            this.photofine = response.photofine;
            this.dicAppliedLimits = response.dicAppliedLimits;
            // лимит — в общее хранилище: его видят формы заявок (быстрый
            // расчёт, избранное, каталог) без отдельного запроса
            this.$store.commit("main/setLimit", response.dicAppliedLimits);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.indexLoading = false;
        });

      getCatalogHome(PAGE_SIZE)
        .then((response) => {
          if (response?.status) {
            this.combos = response.filters || [];
            this.sections = {
              special: response.special || emptySection(),
              used: response.used || emptySection(),
              new: response.new || emptySection(),
            };
            this.catalogLoaded = true;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.catalogLoading = false;
        });
    },
    openTile(tile) {
      if (tile.request) {
        this.itemRequest = { PLType: "Недвижимость" };
        return;
      }
      this.scrollTo(tile.id);
    },
    // плитки «Онлайн-лизинга»: прокрутка к разделу и фокус на нём
    scrollTo(id) {
      const section = document.getElementById(id);
      if (!section) return;
      section.scrollIntoView({ behavior: "smooth", block: "start" });
      section.focus({ preventScroll: true });
    },
    // «Оформить онлайн»: с типом предмета лизинга — расчёт и заявка (как в
    // каталоге), без него онлайн-расчёт не построить — заявка менеджеру
    async apply(item) {
      if (!item.leasing_subject_type) {
        this.itemRequest = fromCatalogItem(item);
        return;
      }
      if (this.applyingId) return;
      this.applyingId = item.id;
      const error = await applyCatalogItem(item, this.$router);
      this.applyingId = null;
      if (error) this.showError(error);
    },
    showError(msg) {
      this.modal = { title: "Ошибка", msg };
    },
    modalClose() {
      this.modal = {};
    },
    pluralOffers(count) {
      const mod10 = count % 10;
      const mod100 = count % 100;
      if (mod10 === 1 && mod100 !== 11) return "предложение";
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14))
        return "предложения";
      return "предложений";
    },
  },
};
</script>
